import React, { useRef, useState, useEffect, useMemo } from "react";
import { useParams, useHistory, Switch } from "react-router-dom";
import PrivateRoute from "@common/components/route/PrivateRoute";
import { Typography, Box } from "@curves/ui-base";
import useDocMembershipSuspendApi from "@apis/useDocMembershipSuspendApi";
import MembershipSuspensionHistory from "@icoach/documents/membership/suspension/MembershipSuspensionHistory";
import MembershipSuspensionContent from "@icoach/documents/membership/suspension/MembershipSuspensionContent";
import { DOC_MEMBERSHIP_SUSPEND_LINK } from "@icoach/documents/membership/staticData";
import { BlankFormBox, SearchBar } from "@icoach/documents/components/";
import { ConfirmTemporaryContractDialog } from "@icoach/documents/dialog";
import { CLUB_DOCUMENTS_ROUTER } from "@icoach/router/routerPath";
import { PEOPLE_TYPE } from "@icoach/constants/";
import { isEqual } from "@util/utils";

const MembershipSuspensionPage = () => {
	const { getInitSuspendOptionApi, getDocTemporarySuspendContractApi, deleteDocTemporarySuspendContractApi } = useDocMembershipSuspendApi();
	const history = useHistory();
	const { peopleType: peopleTypeProps, referenceID: referenceIDProps } = useParams();
	const [options, setOptions] = useState({});
	const [openDialog, setOpenDialog] = useState(false); //有暫存資料時的彈出視窗
	const [isMounted, setMounted] = useState(false);
	const searchRef = useRef([]);
	const temporaryIDRef = useRef(0);

	const checkPeopleType = opts => {
		const { targetOptions = [] } = opts;
		const isInclude = targetOptions.find(({ value }) => isEqual(peopleTypeProps, value));
		if (!peopleTypeProps || !isInclude) {
			history.replace(CLUB_DOCUMENTS_ROUTER.SUSPENSION.GET_PEOPLETYPE_PATH(PEOPLE_TYPE.MEMBER)); // 預設值 有效會員
		}
	};

	// 重設 按鈕
	const handleResetClick = type => {
		const path = CLUB_DOCUMENTS_ROUTER.SUSPENSION.GET_PEOPLETYPE_PATH(type);
		history.replace(path);
	};

	// 搜尋 按鈕
	const handleSearchHistoryClick = id => {
		const { targetID, targetType: peopleType } = searchRef.current.getResult();
		const referenceID = id || targetID;
		const path = CLUB_DOCUMENTS_ROUTER.SUSPENSION.GET_HISTORY_PATH(peopleType, referenceID);
		history.push(path);
	};

	// 新增 按鈕
	const handleCreateClick = () => {
		const { targetID: id, targetType: type } = searchRef.current.getResult();
		const params = { id, type };
		doCreateBlankContractApi(params, type, id);
	};

	// 彈出視窗 要刪除暫存資料
	const handleDialogNoClick = () => {
		const params = {
			id: referenceIDProps,
			type: peopleTypeProps,
		};
		doDeleteTemporaryDataApi(params);
	};

	// 彈出視窗 讀取上次暫存資料繼續編輯
	const handleDialogYseClick = () => {
		if (!temporaryIDRef.current) return;
		const path = CLUB_DOCUMENTS_ROUTER.SUSPENSION.GET_CONTRACT_PATH(peopleTypeProps, referenceIDProps, temporaryIDRef.current);
		setOpenDialog(false);
		history.push(path);
	};

	// 刪除暫存合約資料
	const doDeleteTemporaryDataApi = async parmas => {
		const resp = await deleteDocTemporarySuspendContractApi(parmas);
		if (resp) {
			const path = CLUB_DOCUMENTS_ROUTER.SUSPENSION.GET_CONTRACT_PATH(peopleTypeProps, referenceIDProps, 0);
			setOpenDialog(false);
			history.replace(path);
		}
	};

	// 新增空白頁面
	const doCreateBlankContractApi = async (params, type, id) => {
		let temporaryID;
		temporaryIDRef.current = 0;
		temporaryID = await getDocTemporarySuspendContractApi(params);
		if (temporaryID !== 0 && !!temporaryID) {
			temporaryIDRef.current = temporaryID;
			setOpenDialog(true);
		} else {
			const path = CLUB_DOCUMENTS_ROUTER.SUSPENSION.GET_CONTRACT_PATH(type, id, 0);
			history.push(path);
		}
	};

	// 初始search options
	const doInitOptionsApi = async () => {
		const opts = await getInitSuspendOptionApi();
		if (opts) {
			checkPeopleType(opts);
			setOptions(opts);
		}
		setMounted(true);
	};

	const useSearchBarMemo = useMemo(
		() => {
			return (
				<SearchBar
					ref={searchRef}
					className="mb-4"
					sourceOption={options.targetOptions}
					onResetEvent={handleResetClick}
					onCreateEvent={handleCreateClick}
					onSearchHistoryEvent={handleSearchHistoryClick}
					routerPath={CLUB_DOCUMENTS_ROUTER.SUSPENSION.BASE}
				/>
			);
		},
		// eslint-disable-next-line
		[options]
	);

	useEffect(
		() => {
			doInitOptionsApi();
			return () => setMounted(false);
		},
		// eslint-disable-next-line
		[]
	);

	return (
		<Box className="container contract-membership-suspension main-container-spacing">
			{isMounted && (
				<React.Fragment>
					<Box component="header" className={"page-header"}>
						<Typography className={"page-header-title"} variant={"h3"}>
							會籍暫停申請書
						</Typography>
						<Box className="btn-group">
							<BlankFormBox sourceData={DOC_MEMBERSHIP_SUSPEND_LINK} />
						</Box>
					</Box>
					{useSearchBarMemo}
					<Switch>
						<PrivateRoute exact path={CLUB_DOCUMENTS_ROUTER.SUSPENSION.HISTORY} as={MembershipSuspensionHistory} onBlankContractClick={handleCreateClick} />
						<PrivateRoute exact path={CLUB_DOCUMENTS_ROUTER.SUSPENSION.CONTRACT} as={MembershipSuspensionContent} onReturnHistory={() => handleSearchHistoryClick()} />
						<PrivateRoute exact path={CLUB_DOCUMENTS_ROUTER.SUSPENSION.READONLY_CONTRACT} as={MembershipSuspensionContent} isReadOnly onReturnHistory={() => handleSearchHistoryClick()} />
					</Switch>
				</React.Fragment>
			)}
			<ConfirmTemporaryContractDialog open={openDialog} handleClose={() => setOpenDialog(false)} handleClickYes={handleDialogYseClick} handleClickNo={handleDialogNoClick} />
		</Box>
	);
};

export default MembershipSuspensionPage;
